<template lang="pug">
  div.wrap-item-post-card.py12
    div.post-card.f
      div.wrap-icon.pr6
        div.wrap-img.f.fh
          img(src='/img/avatar-main.png')
          //- img(:src="avatar.iconURL")
      div.card-content
        div.content-head.f.fm.mb2
          span.name.mr6 {{avatar.name}}
          //- span.time {{date}}
        div.content-message.mb6
          span {{card.message}}
        div(v-if="card.img").content-img.mb6
          img(:src="card.img")
    div.wrap-actions.f.flex-right.pt4
      div(@click='onRetweet').quote-retweet.f.fm
        v-icon(color='#ff9999' size='18px').mr2 repeat
        span 引用リツートする
      //- AtomAlike(:postId="card.id" :alikes="card.alikes" :cardAuthor="card.author").mr8
      //- AtomUnlike(:postId="card.id" :unlikes="card.unlikes" :cardAuthor="card.author")

</template>

<style lang="scss" scoped>
.wrap-item-post-card {
  border-bottom: solid 0.6px rgba(0, 0, 0, 0.2);
  .post-card {
    width: 92%;
    margin: 0 auto;
    max-width: 620px;
    .wrap-icon {
      .wrap-img {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        overflow: hidden;
        border: solid 1px rgba(0, 0, 0, 0.2);
        img {
          object-fit: cover;
        }
      }
    }
    .card-content {
      width: calc(100% - 48px);
      .content-head {
        .time {
          color: #999;
          font-size: 12px;
        }
      }
      .content-message {
        span {
          font-size: 12px;
          word-break: break-word;
        }
      }
      .content-img {
        width: 100%;
        img {
          max-width: 100%;
          max-height: 340px;
          object-fit: cover;
        }
      }
    }
  }
  .wrap-actions {
    width: 92%;
    margin: 0 auto;
    max-width: 620px;
    .quote-retweet {
      span {
        font-size: 12px;
        color: #ff9999;
      }
    }
  }
}
</style>

<script>
import moment from 'moment'
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
import AtomAlike from '@/components/atom/AtomAlike'
import AtomUnlike from '@/components/atom/AtomUnlike'

const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
const { mapActions: mapActionsPost } = createNamespacedHelpers('post')

export default {
  components: {
    AtomAlike,
    AtomUnlike
  },
  computed: {
    ...mapStateAuth([
      'uid',
      'isAnonymous'
    ])
  },
  props: {
    card: {
      type: Object,
      require: true
    },
    avatar: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
      date: null
    }
  },
  async created () {
    this.date = moment.unix(this.card.createdAt.seconds).format('ll')
  },
  methods: {
    ...mapActionsPost([
      'setTweetToRetweet'
    ]),
    onRetweet () {
      var tweetURL = `https://twitter.com/${this.card.avatar}/status/${this.card.id}`
      this.setTweetToRetweet(tweetURL)
      this.$router.push(`/post/${this.card.avatar}`)
    }
  }
}
</script>
